'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /** @module transform-props-with */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _castArray = require('lodash/castArray');

var _castArray2 = _interopRequireDefault(_castArray);

var _isPlainObject = require('lodash/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _transformRef = require('./transform-ref');

var _transformRef2 = _interopRequireDefault(_transformRef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A plain object. Should not be mutated.
 * @typedef {object} Props
 * @global
 */

/**
 * Middleware function for changing props.
 * A function which takes Props as input and returns new Props.
 * @callback SimpleTransformation
 * @param {Props} oldProps
 * @return {Props}
 * @global
 */

/**
 * Higher-order React Component.
 * A function that enhances passed component.
 * @callback HigherOrderComponent
 * @param {React.Component} BaseComponent
 * @return {React.Component}
 * @global
 */

/**
 * When a plane object is passed it will be used to
 * extend props (with override).
 * @typedef {(SimpleTransformation|object)} Transformation
 * @global
 */

/**
 * Returns the sum of a and b
 * @param {Transformation} tr
 * @returns {SimpleTransformation}
 * @alias expandShorthands
 * @private
 */
var expandShorthands = function expandShorthands(tr) {
  if (typeof tr === 'function') {
    return tr;
  }

  if ((0, _isPlainObject2.default)(tr)) {
    return function (oldProps) {
      return _extends({}, oldProps, tr);
    };
  }

  throw new Error('Transformation must be a function or a plain object.');
};

/**
 * A list of default transformations
 * @private
 */
var defaultTransformations = [_transformRef2.default];

/**
 * Higher-order component generator.
 * Will change props with passed transformaton(s).
 * Array of transformatons is evaluated left to right.
 * @function default
 * @param {Transformation|Transformation[]} [transformations = []]
 * @returns {HigherOrderComponent}
 */

exports.default = function () {
  var transformations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var userTransformations = (0, _castArray2.default)(transformations).map(expandShorthands);
  var transformsList = defaultTransformations.concat(userTransformations);

  var transform = Array.prototype.reduce.bind(transformsList, function (props, tr) {
    return tr(props);
  });

  return function (Component) {
    return function (props) {
      return _react2.default.createElement(Component, transform(props));
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/transform-props-with/lib/index.js
// module id = 14
// module chunks = 0